import type { CreditBankSummary, Wallet } from '@/modules/account/types'
import { BreakdownTable } from './BreakdownTable'
import {
  filingBreakdownRows,
  folderBreakdownRows,
  projectBreakdownRows,
} from './toBreakdownRows'

export const BreakdownTables = ({
  wallet,
  summary,
}: {
  wallet: Wallet
  summary: CreditBankSummary
}) => {
  if (wallet === 'screenings') {
    return (
      <BreakdownTable
        title="Breakdown by filing"
        rows={filingBreakdownRows(summary.filingBreakdown)}
      />
    )
  }

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <BreakdownTable
        title="Breakdown by project"
        rows={projectBreakdownRows(summary.projectBreakdown)}
      />
      <BreakdownTable
        title="Breakdown by folder"
        rows={folderBreakdownRows(summary.folderBreakdown)}
      />
    </div>
  )
}
